import React, { useState } from "react";
import { Modal, Input, notification, Form } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getError } from "../../utils/form";

const { TextArea } = Input;

const schema = yup.object().shape({
  subject: yup.string().required("Field can't be empty"),
  message: yup.string().required("Field can't be empty"),
});

const openNotification = () => {
  notification.success({
    message: "Success!",
    description:
      "Your concern is shared with our team. An Admin will get back to you",
    onClick: () => {
      console.log("Notification Clicked!");
    },
  });
};

const ControlledInput = ({
  control,
  errors,
  name,
  label,
  required,
  setSubjectError,
}) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          required={required}
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Input
            {...field}
            onFocus={() => {
              setSubjectError(false);
            }}
          />
        </Form.Item>
      )}
    />
  );
};

const ControlledTextArea = ({
  control,
  errors,
  name,
  label,
  required,
  setMessageError,
}) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          required={required}
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <TextArea
            rows={4}
            {...field}
            onFocus={() => {
              setMessageError(false);
            }}
          />
        </Form.Item>
      )}
    />
  );
};

const ContactSupportForm = ({ visible, setVisible, onSave, loading }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      subject: "",
      message: "",
    },
    resolver: yupResolver(schema),
  });

  const [subjectError, setSubjectError] = useState(null);
  const [messageError, setMessageError] = useState(null);

  const handleSuccess = () => {
    reset();
    setVisible(false);
    openNotification();
  };

  const handleFailure = () => {
    notification.error({
      message: "Failure!!",
      description: "There was some error",
    });
  };

  const onSubmit = (data) => {
    if (data.subject.trim().length === 0) setSubjectError(true);
    else if (data.message.trim().length === 0) setMessageError(true);
    else {
      const payloadData = {
        subject: data.subject,
        message: data.message,
      };
      const payload = {
        onSuccess: handleSuccess,
        data: payloadData,
        onFailure: handleFailure,
      };
      onSave(payload);
    }
  };

  const handleCancel = () => {
    reset();
    setVisible(false);
    setMessageError(false);
    setSubjectError(false);
  };

  return (
    <Modal
      title="Contact Support"
      visible={visible}
      okText="Submit"
      okButtonProps={{ loading: loading }}
      onOk={handleSubmit(onSubmit)}
      onCancel={handleCancel}
    >
      <p style={{ fontWeight: "500", fontSize: "16px" }}>
        If you have a question about our service or have an issue to report,
        please send a request and we will get back to you as soon as possible.
      </p>
      <p style={{ fontWeight: "500", fontSize: "14px" }}>Subject :</p>
      <ControlledInput
        required={true}
        name="subject"
        errors={errors}
        control={control}
        setSubjectError={setSubjectError}
      />
      {subjectError && (
        <p style={{ color: "red", fontSize: "14px" }}>Please add subject</p>
      )}
      <p style={{ marginTop: "10px", fontWeight: "500", fontSize: "14px" }}>
        Message:
      </p>
      <ControlledTextArea
        required={true}
        name="message"
        errors={errors}
        control={control}
        setMessageError={setMessageError}
      />
      {messageError && (
        <p style={{ color: "red", fontSize: "14px" }}>Please add message</p>
      )}
    </Modal>
  );
};

export default ContactSupportForm;
